'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'sword-laser';
var width = 640;
var height = 512;
var aliases = [];
var unicode = 'e03b';
var svgPathData = 'M328.7 326.5l8.5 8.5c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-96-96c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l8.5 8.5 329.4-292.8c11.9-10.6 29.9-10 41.1 1.2S632-14.7 621.5-2.9L328.7 326.5zm-47.1 64.1l-30.1 30.1-96-96 30.1-30.1 96 96zm-78.1 78.1l-96-96 25.4-25.4 96 96-25.4 25.4zM85 395.3l96 96-62.1 62.1c-12.5 12.5-32.8 12.5-45.3 0L22.9 502.6c-12.5-12.5-12.5-32.8 0-45.3L85 395.3z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSwordLaser = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;